<template>
  <div class="period-filter">
    <v-menu
      v-model="menuOpen"
      :close-on-content-click="false"
      offset-y
      min-width="auto"
    >
      <template #activator="{ on, attrs }">
        <button
          class="period-filter-pill period-filter-pill--custom is-active"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="14" left>mdi-calendar-range</v-icon>
          {{ label }}
        </button>
      </template>
      <v-card class="period-filter-picker" flat>
        <v-date-picker
          v-model="range"
          range
          no-title
          locale="pt-br"
          color="#0f7a6e"
          :max="maxDate"
        />
        <div class="period-filter-picker-actions">
          <span class="hint">{{ rangeHint }}</span>
          <v-btn small color="#0f7a6e" dark depressed :disabled="range.length < 2" @click="applyCustom">
            Aplicar
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "PeriodFilter",
  props: {
    label: { type: String, default: "" },
  },
  data() {
    return {
      menuOpen: false,
      // Sem os presets, o filtro comeca com "hoje" ja selecionado no proprio
      // calendario -- range com a mesma data duas vezes = um unico dia.
      range: [this.todayIso(), this.todayIso()],
    };
  },
  computed: {
    // Sempre "hoje" (hora local) — nao pode ser data fixa, senao o calendario
    // trava no passado conforme o tempo passa.
    maxDate() {
      return this.todayIso();
    },
    rangeHint() {
      if (this.range.length === 0) return "Selecione a data inicial";
      if (this.range.length === 1) return "Selecione a data final";
      return `${this.range[0].split("-").reverse().join("/")} → ${this.range[1]
        .split("-")
        .reverse()
        .join("/")}`;
    },
  },
  methods: {
    todayIso() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
    },
    applyCustom() {
      if (this.range.length < 2) return;
      const [a, b] = [...this.range].sort();
      const toDate = (iso) => {
        const [y, m, d] = iso.split("-").map(Number);
        return new Date(y, m - 1, d);
      };
      this.menuOpen = false;
      this.$emit("change", { key: "custom", start: toDate(a), end: toDate(b) });
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
